import { LoadableAfterPaint } from '@confluence/loadable';

export const UserProfileMacroHandler = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-UserProfileMacro" */ '../src/user-profile/UserProfileMacroRenderer.tsx'
			)
		).UserProfileMacroRenderer,
});
